import isNil from 'lodash/isNil';
import reduce from 'lodash/reduce';
import forEach from 'lodash/forEach';

import getStorageValue from '~/misc/getStorageValue';
import safeJSONParse from '~/misc/safeJSONParse';
import canUseLocalStorage from '~/misc/canUseLocalStorage';
import Stripecheckout from "react-stripe-checkout";
import React from "react";

import testConfig from './test-config';
import prodConfig from './prod-config';

let config = {};
if (process.env.NODE_ENV === 'production') {
  config = prodConfig;
} else {
  config = testConfig;
}

const completed = {
  tabTitleAndRow: '',
  InstantLoadMap: '',
  descriptiveBackhaulPreview: '',
  backhaulWithoutPreview: '',
  previewPhone: '',
  anonBanerTextAndAction: '',
  // tabTitleNotifications: '',
};

if (canUseLocalStorage) {
  forEach(completed, (_, key) => {
    localStorage.removeItem(key);
  });
  localStorage.removeItem('alternativeMap');
  localStorage.removeItem('backhaul2');
}


let initTests = {};

const getRandomBoolen = () => Boolean(Math.round(Math.random()));
// const createVariator = (variantsAmount) =>
//   () => Math.min((Math.floor(Math.random() * variantsAmount) + 1), variantsAmount);

forEach({
  anonBanerTextAndAction2: getRandomBoolen,
  poi2: getRandomBoolen,
  loadIntroduction: getRandomBoolen,
  priceDescription2: getRandomBoolen,
  anyDateMark: getRandomBoolen,
  backhaulDirections2: getRandomBoolen,
}, (init, testKey) => {
  let value = safeJSONParse(getStorageValue(testKey));

  if (canUseLocalStorage && isNil(value)) {
    value = init();
    window.localStorage.setItem(testKey, JSON.stringify(value));
  }

  initTests[testKey] = value;
});

const tests = {
  anonBanerTextAndAction2: initTests.anonBanerTextAndAction2,
  poi2: false,//initTests.poi2,
  loadIntroduction: initTests.loadIntroduction,
  brokerCardAndSeachCompleted: true,
  priceDescription2: initTests.priceDescription2,
  notFound2: true,
  requestBookButton: true,
  bookingAtTop: true,
  reportingSkippedBooknow: true,
  anyDateMark: initTests.anyDateMark,
  backhaulDirections2: initTests.backhaulDirections2,
};

const testsList = reduce(tests,
  (results, value, key) =>
    [...results, `${key}=${value}`], []
);

export const commonEnvProps = {
  ...completed,
  ...tests,
  ab_tests: testsList,
  userbanner: true,

  screenWidth: window.screen.availWidth,
  windowWidth: window.innerWidth,
};

export default {
  loadsUpdatingInterval: getStorageValue('loadsUpdatingInterval', 20 * 1000),
  metricsToConsole: safeJSONParse(getStorageValue('metricsToConsole')),
  disableAnalyticsTracking: safeJSONParse(getStorageValue('disableAnalyticsTracking')),
  // intercom: 'xw8a5b11',

  anonBanerTextAndAction: tests.anonBanerTextAndAction2,
  offers: 'phone',
  poi2: tests.poi2,
  loadIntroduction: tests.loadIntroduction,
  brokerCard: true,
  brokersSearch: true,
  priceDescription2: tests.priceDescription2,
  backhaulDirections2: tests.backhaulDirections2,
  backhaulDates: true,
  anyDateMark: tests.anyDateMark,
  ...config
};

// export const globalUrlParams = ['test_no_close', 'hold2', 'hold3', 'anon']
export const globalUrlParams = {
  global: ['test_no_close', 'hold2', 'hold3', 'anon'],
  router: [
    {
      path: '',
      regExp: /(^\/searchloads.*|\/loads$)/,
      params: ['from_state_name', 'from_country_name']
    }
  ],
  logOutDelete: ['test_no_close', 'hold2', 'hold3', 'anon']
}


// WEBPACK FOOTER //
// ./src/config.js